import { Card, Col, Flex, Row, Skeleton, Typography } from 'antd';
import { useState } from 'react';
import { InternshipOfferAppliedComponent } from './InternshipOfferAppliedComponent';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import {
  useInternshipOffers,
  useStudentApplications,
} from '../../hooks/useInternshipOffers';
import { useCurrentStudyYear } from '../../hooks/useStudyYear';
import { StudyYearDropdown } from '../StudyYearDropdown';
import noPendingInternshipOffer from '../../Assets/Images/NoPendingInternshipOffers.png';
import { useTranslation } from 'react-i18next';

export const PendingInternshipOffersComponent = () => {
  const loggedInUser = useCurrentUser();
  const { data: internshipOffers, isLoading: internshipOfferIsLoading } =
    useInternshipOffers();
  const { data: allStudentApplications } = useStudentApplications(
    loggedInUser?.id
  );
  const { t } = useTranslation();
  // undefined until the student selects a study year, then the dropdown shows the current one
  const [selectedStudyYearId, setSelectedStudyYearId] = useState<number>();
  const { data: currentStudyYear } = useCurrentStudyYear();

  // the dropdown shows the current study year until the student selects another one, the same is filtered here
  const shownStudyYearId = selectedStudyYearId ?? currentStudyYear?.id;

  const studentApplications = allStudentApplications?.filter(
    (studentApplication) => studentApplication.studyYearId === shownStudyYearId
  );

  const appliedInternshipOffersByStudent = internshipOffers?.filter((offer) =>
    studentApplications?.some(
      (studentApplication) => studentApplication.internshipOfferId === offer.id
    )
  );

  const studyYearSelector = (
    <Flex
      align="center"
      justify="start"
      gap={8}
      wrap
      style={{ marginBottom: 10 }}
    >
      <Typography.Text strong>{t('studyYear.label')}:</Typography.Text>
      <StudyYearDropdown
        value={selectedStudyYearId}
        onChange={setSelectedStudyYearId}
      />
    </Flex>
  );

  if (internshipOfferIsLoading) {
    return (
      <Flex gap={8} wrap>
        {Array.from({ length: 5 }).map((_, index) => {
          return (
            <Card
              key={index}
              style={{
                width: 500,
                height: 230,
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              }}
            >
              <Skeleton />
            </Card>
          );
        })}
      </Flex>
    );
  }

  if (
    appliedInternshipOffersByStudent &&
    appliedInternshipOffersByStudent?.length > 0
  ) {
    return (
      <>
        {studyYearSelector}
        <Flex gap={8} wrap>
          {appliedInternshipOffersByStudent?.map((offer, index) => {
            // replace internship offer status with internship application status
            const matchedApplication = studentApplications?.find(
              (application) => application.internshipOfferId === offer.id
            );
            console.log('Applied');
            console.log(appliedInternshipOffersByStudent);
            console.log('studentapplication:');
            console.log(studentApplications);

            return (
              <InternshipOfferAppliedComponent
                key={index}
                internshipOffer={offer}
                studentApplication={matchedApplication}
                organizationId={offer.organizationId}
              />
            );
          })}
        </Flex>
      </>
    );
  } else {
    return (
      <>
        {studyYearSelector}
        <Row
          justify="center"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            flex: 1,
            minHeight: 0,
            padding: '24px',
            overflow: 'hidden',
          }}
        >
          <Col xs={24} sm={16} md={12} lg={18} style={{ marginTop: 45 }}>
            <img
              src={noPendingInternshipOffer}
              alt="noPendingInternshipOfferImg"
              style={{
                display: 'block',
                margin: '0 auto',
                width: '100%',
                maxWidth: '320px',
                height: 'auto',
                opacity: 0.5,
              }}
            />

            <Flex align="center" justify="center" style={{ marginTop: 25 }}>
              <Typography.Text
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#8c8c8c',
                  textAlign: 'center',
                }}
              >
                {t('pendingInternshipOffersComp.noPendingOffersFound')}
              </Typography.Text>
            </Flex>
          </Col>
        </Row>
      </>
    );
  }
};
